import ConsultationsUser from 'features/consultations/consultationsUser';
import { useTitle } from '../helpers';

/**
 * @page Consultation user page
 */
const ConsultationUserPage = () => {
  useTitle('Информация о консультации');

  return (
    <div>
      <h3>Страница информации о консультации</h3>
      <ConsultationsUser />
    </div>
  );
};

export default ConsultationUserPage;
